import { axiosRequest } from "../../configs/axios.config";

export class ClosingReasonService {
  getAll(success, error) {
    axiosRequest
      .get("closing_reasons")
      .then(({ data }) => success(data))
      .catch((err) => error(err));
  }

  create(data, success, error) {
    axiosRequest
      .post("closing_reasons", data)
      .then(({ data }) => success(data))
      .catch((err) => error(err));
  }

  update(id, data, success, error) {
    axiosRequest
      .put(`closing_reasons/${id}`, data)
      .then(({ data }) => success(data))
      .catch((err) => error(err));
  }

  delete(id, success, error) {
    axiosRequest
      .delete(`closing_reasons/${id}`)
      .then(({ data }) => success(data))
      .catch((err) => error(err));
  }
}
